module.exports = __webpack_public_path__ + "static/media/iar_vehicle_other.f1f27872.svg";